(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const tabToggles = document.querySelectorAll('.product-tabs-toggle');
    const tabContents = document.querySelectorAll('.product-tab');
  
    tabToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const target = toggle.getAttribute('data-tab');
  
        // Remove active class from all toggles and tabs
        tabToggles.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(tab => tab.classList.remove('active'));
  
        // Add active to current
        toggle.classList.add('active');
        const activeTab = document.querySelector(`.product-tab[data-tab="${target}"]`);
        if (activeTab) activeTab.classList.add('active');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
